'use client';

import {FC} from 'react';

import {useOpenTelemetryWebVitals} from '../utils/useOpenTelemetryWebVitals';

import {useBrowserOtelLifecycle} from './hooks';

/**
 * Client-side OpenTelemetry provider that initializes the browser tracing, metrics, and logging
 * pipelines as a singleton. On mount it sets up the WebTracerProvider, MeterProvider, and OTLP
 * logger, then attaches global listeners for uncaught errors, unhandled rejections, CSP violations,
 * and telemetry flushing on visibility/page-hide events. It also collects Web Vitals metrics.
 * Render once near the root of the client tree — multiple mounts are ref-counted so Strict Mode
 * double-renders are safe.
 */
export const BrowserOtelProvider: FC = () => {
  useBrowserOtelLifecycle();
  useOpenTelemetryWebVitals();

  return null;
};
